import { Component } from '@angular/core';

import { ComponentsService } from '../../services/components.service';
import { StorageManagerService } from 'src/app/storage/services/storage-manager.service';
import { AttributeDataService } from '../../services/attribute-data.service';

@Component({
  selector: 'template-component',
  templateUrl: './template-component.component.html',
  styleUrls: ['./template-component.component.scss'],
  standalone: false,
})
export class TemplateComponentComponent {
  constructor(
    public componentsService: ComponentsService,
    public storageManagerService: StorageManagerService,
    private attributeDataService: AttributeDataService,
  ) {}

  getComponentLabel(component: any): string {
    return component
      ? this.attributeDataService.getAvailableAttributeData(
          component.id,
          'editorLabel',
        ) || this.componentsService.getComponentTitle(component)
      : '';
  }

  get headerMode(): 'default' | 'canva' | 'back-title' {
    if (
      this.componentsService.isBackTitleHeaderVisible(
        this.componentsService.selected,
      )
    ) {
      return 'back-title';
    }
    if (this.isCanvaConnectSelecting()) {
      return 'canva';
    }
    return 'default';
  }

  isCanvaConnectSelecting(): boolean {
    const selected = this.componentsService.selected;
    if (!selected) {
      return false;
    }
    const componentType = selected.type || selected.tagName;
    const type = this.attributeDataService.getAvailableAttributeData(
      selected.id,
      'type',
    );
    if (
      (componentType !== 'rise-folder' &&
        componentType !== 'rise-canva-connect') ||
      type !== 'canva'
    ) {
      return false;
    }
    const source = this.attributeDataService.getAvailableAttributeData(
      selected.id,
      'source',
    );
    const directive = this.componentsService.getSelectedDirective();
    const isAuthenticating = directive?.isAuthenticating?.() || false;
    return !source && !isAuthenticating;
  }
}
